// extracted by mini-css-extract-plugin
export default {"page_title":"Home_page_title__qgQwn"};